import ChangePasswordForm from '@/components/ChangePassword/ChangePasswordForm';
import {
  useResponsiveFontSize,
  useResponsiveHeight,
  useResponsiveWidth,
} from '@/hooks/useResponsiveDimensions';
import { Image, StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';
import { isPatientApp } from '@/config/constants';
import TherapistPasswordChangeForm from '@/components/ChangePassword/TherapistPasswordChangeForm';
import { styles } from './styles';

export const PasswordChangeScreen = () => {
  const responsiveFontSizeValue1 = useResponsiveFontSize(1);
  const responsiveStyles = StyleSheet.create({
    logoWrapper: {
      width: useResponsiveWidth(40),
      height: useResponsiveHeight(10),
      marginTop: responsiveFontSizeValue1,
      alignSelf: 'center',
    },
    logoStyle: {
      resizeMode: 'contain',
      width: '100%',
      height: '100%',
    },
  });

  const renderPatientHeader = () => (
    <>
      <View style={responsiveStyles.logoWrapper}>
        <Image
          source={require('@/assets/neolexon_Logo_ohneClaim.png')}
          style={responsiveStyles.logoStyle}
        />
      </View>
      <View style={styles.titleWrapper}>
        <Text style={styles.titleText}>Passwort ändern</Text>
      </View>
    </>
  );

  return (
    <View style={styles.container}>
      {isPatientApp ? renderPatientHeader() : null}
      {isPatientApp ? <ChangePasswordForm /> : <TherapistPasswordChangeForm />}
    </View>
  );
};
